import { render, staticRenderFns } from "./SystemBugNotification.vue?vue&type=template&id=0d2487b1&scoped=true&"
import script from "./SystemBugNotification.vue?vue&type=script&lang=js&"
export * from "./SystemBugNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2487b1",
  null
  
)

export default component.exports